// extracted by mini-css-extract-plugin
export default {"InputContainer":"GateValidation_InputContainer__7kWhm","errorMessage":"GateValidation_errorMessage__iW3VQ"};